import { NavItem } from '@/app-shell/layout/Navigation/sidebar';
import { ConciergeBell, Phone, Pill, SquareCheck, Stethoscope } from 'lucide-react';

export interface TasksNavItemProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
}

export function TasksNavItem({ label, isActive, onClick }: TasksNavItemProps) {
  return (
    <NavItem
      label={label}
      icon={<SquareCheck />}
      href="/tasks"
      isActive={isActive}
      onClick={onClick}
      testId="sidebar-link-view-tasks"
    />
  );
}

export interface TriageNavItemProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
}

export function TriageNavItem({ label, isActive, onClick }: TriageNavItemProps) {
  return (
    <NavItem
      label={label}
      icon={<Stethoscope />}
      href="/triage"
      isActive={isActive}
      onClick={onClick}
      testId="sidebar-link-view-triage"
    />
  );
}

export interface ConciergeNavItemProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
}

export function ConciergeNavItem({ label, isActive, onClick }: ConciergeNavItemProps) {
  return (
    <NavItem
      label={label}
      icon={<ConciergeBell />}
      href="/concierge"
      isActive={isActive}
      onClick={onClick}
      testId="sidebar-link-view-concierge"
    />
  );
}

export interface RefillsNavItemProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
}

export function RefillsNavItem({ label, isActive, onClick }: RefillsNavItemProps) {
  return (
    <NavItem
      label={label}
      icon={<Pill />}
      href="/refills"
      isActive={isActive}
      onClick={onClick}
      testId="sidebar-link-view-refills"
    />
  );
}

export interface CallsNavItemProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
}

export function CallsNavItem({ label, isActive, onClick }: CallsNavItemProps) {
  return (
    <NavItem
      label={label}
      icon={<Phone />}
      href="/comms"
      isActive={isActive}
      onClick={onClick}
      testId="sidebar-link-view-calls"
    />
  );
}
